// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"38":"0ab198ed17c7b250","579":"f2b8d11af8fa6469"}[chunkId] + ".js";
};